import { useEffect, useState } from "react";

const useScript = (src, globalVar) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!src) return;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    const onScriptLoad = () => {
      setIsLoaded(true);
    };

    script.addEventListener("load", onScriptLoad);
    document.body.appendChild(script);

    return () => {
      script.removeEventListener("load", onScriptLoad);
      document.body.removeChild(script);
    };
  }, [src, globalVar]);

  return isLoaded;
};

export default useScript;
